import { useState, useEffect } from 'react';
import masterThemesApi from '../api/masterThemes';

function unwrap(resp) {
  if (!resp) return null;
  return resp.data?.data ?? resp.data ?? null;
}

export default function useMasterThemes() {
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await masterThemesApi.list();
      const payload = unwrap(resp);
      let list = [];
      if (Array.isArray(payload)) list = payload;
      else if (Array.isArray(payload?.items)) list = payload.items;
      else if (Array.isArray(payload?.themes)) list = payload.themes;
      else if (payload) {
        if (payload.id || payload.name) list = [payload];
      }
      setThemes(list);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const create = async (payload, config) => {
    const resp = await masterThemesApi.create(payload, config);
    await load();
    return resp;
  };

  const update = async (id, payload, config) => {
    const resp = await masterThemesApi.update(id, payload, config);
    await load();
    return resp;
  };

  const remove = async (id) => {
    const resp = await masterThemesApi.remove(id);
    await load();
    return resp;
  };

  const get = (id) => masterThemesApi.get(id).then(unwrap);

  return { themes, loading, error, load, create, update, remove, get };
}
